import React from "react";

const Invoice = () => {
  return <div><h1>Work In Progress......</h1></div>;
};

export default Invoice;